import jwtDecode from "jwt-decode";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  decode: (token) => jwtDecode(token),
};
